<template>
  <div class="row">
    <div class="col">
      <div
        class="container-fluid col-md-11"
        style="
          background: rgb(248, 249, 250);
          border-radius: 10px;
          box-shadow: 5px 5px 5px 5px #999999;
        "
        id="contenedor"
      >
      <div class="d-flex justify-content-center">
							<div class="row">
								<div class="col">
								<br>
								<img src="https://seguimiento.cmimbral.cl/assets/logo_tienda.png"  width="200" class="img-fluid" alt="Responsive image"><br>
								</div>
							</div>
							
                        </div><br>
            <h3 class="text-center"><b>Buscar Cheque</b></h3><br>
      <div class="d-flex justify-content-center">
        <div class="row">
          <div class="col">
<label>Buscar por</label>
                    <select class="form-select" aria-label="Default select example" id="busqueda" @change="cambio()" style="border-color: rgb(237, 126, 37);">
                      <option value="1">N° Documento</option>
                      <option value="2">Vendedor y fecha</option>
                      <option value="3">RUT facturación y fecha</option>
                      <option value="4">Razón social y fecha</option>
                      </select><br><br>
          </div>
        </div>
        
      </div>
        
							<div id="bVendedor" style="display:none">
							<div class="row">
							<div class="col-sm-4">
                                <div class="form-group">
                                    <label for="comuna" ><strong>Vendedor</strong></label>
                                     <select class="form-select" id="vendedor" aria-label="Default select example"  style="border-color: rgb(237, 126, 37);">
									</select>
                                </div>
                            </div>
							<div class="col-sm-3">
								<label ><strong>Fecha desde</strong></label><br>
								<input type="date" class="form-control" id="fecha1v" style=" border: solid 1px; border-radius: 5px;border-color:rgb(237,126,37) "/>
								
							</div>
                            <div class="col-sm-3">
								<label ><strong>Fecha hasta</strong></label><br>
								<input type="date" class="form-control" id="fecha2v" style=" border: solid 1px; border-radius: 5px; border-color:rgb(237,126,37)"/>
                            </div>
								
								<div class="col-sm"><label for="btnBuscar" ><strong>Buscar</strong></label><br>
										<button type="submit"  id="btnBuscar" class="btn btn-primary" @click="buscarVendedor()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search"></i></button>
								</div>
                        </div><br><br>
							
						</div>	

            <div id="bRUT" style="display:none">
							<div class="row">
							<div class="col-sm-4">
                <label ><strong>RUT</strong></label><br>
                                <input type="text" class="form-control "  id="rut" placeholder="Ingrese RUT" required="true"  style="border-color:rgb(237,126,37)"  @keyup="leer()">
                            </div>
							<div class="col-sm-3">
								<label ><strong>Fecha desde</strong></label><br>
								<input type="date" class="form-control" id="fecha1RUT" style=" border: solid 1px; border-radius: 5px;border-color:rgb(237,126,37) "/>
								
							</div>
                <div class="col-sm-3">
								<label ><strong>Fecha hasta</strong></label><br>
								<input type="date" class="form-control" id="fecha2RUT" style=" border: solid 1px; border-radius: 5px; border-color:rgb(237,126,37)"/>
                            </div>
								
								<div class="col-sm"><label for="btnBuscar" ><strong>Buscar</strong></label><br>
										<button type="submit"  id="btnBuscar" class="btn btn-primary" @click="buscarRut()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search"></i></button>
								</div>
                        </div><br><br>
							
						</div>

            <div id="bRazon" style="display:none">
							<div class="row">
							<div class="col-sm-4">
                <label ><strong>Razón social</strong></label><br>
                               <input type="text" class="form-control "  id="razon" placeholder="Ingrese Razón Social" required="true"  style="border-color:rgb(237,126,37)">
                            </div>
							<div class="col-sm-3">
								<label ><strong>Fecha desde</strong></label><br>
								<input type="date" class="form-control" id="fecha1Razon" style=" border: solid 1px; border-radius: 5px;border-color:rgb(237,126,37) "/>
								
							</div>
                            <div class="col-sm-3">
								<label ><strong>Fecha hasta</strong></label><br>
								<input type="date" class="form-control" id="fecha2Razon" style=" border: solid 1px; border-radius: 5px; border-color:rgb(237,126,37)"/>
                            </div>
								
								<div class="col-sm"><label for="btnBuscar" ><strong>Buscar</strong></label><br>
										<button type="submit"  id="btnBuscar" class="btn btn-primary" @click="buscarRazon()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search"></i></button>
								</div>
                        </div><br><br>
							
						</div>
 
        <div id="bDocumento">
        
          <div class="row">
            <div class="col-sm-3"></div>
            <div class="col-sm-5">
              <input type="text" class="form-control form-control-lg"  id="numero" placeholder="Ingrese n° de documento" required="true"  style="border-color:rgb(237,126,37)">
            </div>
            <div class="col-sm">
              <button type="submit"  id="btnBuscar" class="btn btn-primary btn-lg" @click="buscarDocumento()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search"></i></button>
            </div>
          </div>
        </div><br><br>
        <h3 id="cantidadCheques" style="display:none">Total de cheques en la tabla: {{largo}}</h3>

        <table class="table table-striped table-responsive" style="display:block">
           <thead style="background-color:rgb(0,58,140);color:white">
            <tr>
              <th>N° doc</th>
              <th>RUT facturación</th>
              <th>RUT titular</th>
              <th>Nombre titular</th>
              <th>Razón social</th>
              <th>Monto</th>
              <th>Fecha</th>
              <th>Observacion</th>
              <th>Archivo</th>
              <th>Quitar Archivo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="cheque in Cheques" :key="cheque.key">
              <td>{{ cheque.documento }}</td>
              <td>{{ cheque.rutFacturacion }}</td>
              <td>{{ cheque.rut }}</td>
              <td>{{ cheque.nombreTitular }}</td>
              <td>{{ cheque.razonSocial }}</td>
              <td>{{ cheque.monto }}</td>
              <td>{{ cheque.fecha}}</td>
              <td>{{ cheque.observacion }}</td>
              <td v-if="cheque.imagen!=null && cheque.imagen!=''">
                <button
                  type="button"
                  @click="verArchivo(cheque.imagen)"
                  class="btn btn-success btn-sm"
                  style="
                    background-color: rgb(0, 56, 143);
                    color: white;
                    border-color: rgb(237, 126, 37);
                  "
                >
                 <i class="far fa-image fa-2x"></i>
                </button>
              </td>
              <td v-else>
                <h6 style="color:#ED7E25"><b>NO</b> </h6>
              </td>
              <td v-if="cheque.imagen!=null && cheque.imagen!=''">
                
                <button 
                
                  type="button"
                  
                  class="btn btn-success btn-sm"
                  style="
                    background-color: rgb(0, 56, 143);
                    color: white;
                    border-color: rgb(237, 126, 37);
                  "
                  @click="cargarDatos(cheque.key)"
                >
                 <i class="fas fa-ban fa-2x"></i>
                </button>
              </td>
              <td v-else>
                <h6 style="color:#ED7E25"><b>NO</b> </h6>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <iframe id="pdf" width="100%" height="800px"></iframe>
      </div>
    </div>
    <div>

  <b-modal id="modal-1" hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Editar Cheque</b></h3><br>
      
                <input type="text" id="key" v-model="key" class="form-control" placeholder="Ingrese RUT facturación" style=""  >
                         
                <div class="row">
                
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>RUT facturación</label>
                        <input type="text" id="rutF" v-model="rutFacturacion" class="form-control" placeholder="Ingrese RUT facturación" style="border-color:rgb(237,126,37)"  required>
                         </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>N° documento</label>
                        <input type="text" id="nDoc" v-model="documento" class="form-control" placeholder="Ingrese n° documento" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    
                    
                </div><br>
                
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>RUT titular</label>
                        <input type="text" id="rutT" v-model="rut" class="form-control" placeholder="Ingrese RUT" style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Nombre titular</label>
                        <input type="text" id="nombreT" v-model="nombreTitular" class="form-control" placeholder="Ingrese nombre" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                   
                </div><br>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>Razón social</label>
                        <input type="text" id="razonS" v-model="razonSocial" class="form-control" placeholder="Ingrese nombre" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label>Monto del cheque</label>
                            <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" style="border-color:rgb(237,126,37)">$</span>
                            </div>
                           <input type="text" id="monto" v-model="monto" class="form-control" placeholder="Ingrese monto" style="border-color:rgb(237,126,37)"  required>
                        
                            </div>
                    </div>
                </div><br>
                <div class="row">
                    <div class="form-group">
                        <label for="observacion">Observacion</label>
                        <textarea class="form-control" id="observacion" v-model="observacion" rows="3"  style="border-color:rgb(237,126,37)"></textarea><br>
                    </div>
                </div>
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="editar()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Editar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal>
</div>
  </div>
  
</template>

<script>
import { db } from "../firebaseDb";
import { storage } from "../firebaseDb";
import Swal from "sweetalert2";
import Vue from 'vue'
    import { BootstrapVue } from 'bootstrap-vue'
    Vue.use(BootstrapVue)
const ref = storage.ref();

export default {
  data() {
    return {
      Cheques: [],
      vendedores:[],
      editado:[],
      chequeEditado:[],
      observacion:'',
      key:'',
        rutFacturacion:'',
        documento:'',
        rut:'',
        nombreTitular:'',
        razonSocial:'',
        monto:'',
        largo:'',
    };
  },
  created() {
            document.getElementById("nav").style.display="none";
            document.getElementById("navCreditos").style.display="block";
            document.getElementById("navContabilidad").style.display="none";
            this.usuario=localStorage.usuario;
            console.log(this.usuario)
            this.cargarVendedores();
            this.validarUsuario();  
   
    
  },
  methods: {
    cargarVendedores(){
              //  var vendedor = document.getElementById("vendedores")
                db.collection('usuarios').where("tipo", "==", 1).onSnapshot((snapshotChange) => {
                this.vendedores = [];
                snapshotChange.forEach((doc) => {
                    var option = document.createElement("option")
                    option.value = doc.data().rut,
                    option.innerHTML = doc.data().nombre,
                    document.getElementById("vendedor").appendChild(option)
                    /*this.vendedores.push({
                        key: doc.id,
                        nombre: doc.data().nombre,
                        rut: doc.data().rut,
                        
                    })*/
                });
            })
            },
    eliminar(id) {
      if (window.confirm("Realmente deseas eliminar el cheque?")) {
        db.collection("cheques")
          .doc(id)
          .delete()
          .then(() => {
            Swal.fire({
            title: "Listo",
            text: "Cheque eliminado",
            icon: "success",
          });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    verArchivo(imagen) {
      console.log(imagen);
      document.getElementById("pdf").src = "";
      console.log(imagen);
      const refImg = ref
        .child("archivos/" + imagen)
        .getDownloadURL()
        .then(function (url) {
          console.log(refImg);
          var img = document.getElementById("pdf");
          img.src = url;
        })
        .catch(function (error) {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "No hay imagen asociada",
            icon: "error",
          });
        });
    },
    cambio(){
      var busqueda=document.getElementById("busqueda").value;
      this.largo='';
      console.log(busqueda)
      if(busqueda=="1"){
        this.Cheques=[];
        document.getElementById('pdf').src="";
          document.getElementById("bDocumento").style.display="block"; 
          document.getElementById("bVendedor").style.display="none";
          document.getElementById("bRUT").style.display="none";
          document.getElementById("bRazon").style.display="none";
          document.getElementById("cantidadCheques").style.display="none";
      }else if(busqueda=="2"){
        this.Cheques=[];
        document.getElementById('pdf').src="";
        document.getElementById("bVendedor").style.display="block";
        document.getElementById("bDocumento").style.display="none";
         document.getElementById("bRUT").style.display="none";
          document.getElementById("bRazon").style.display="none";
          document.getElementById("cantidadCheques").style.display="block";
      }else if(busqueda=="3"){
        this.Cheques=[];
        document.getElementById('pdf').src="";
        document.getElementById("bVendedor").style.display="none";
        document.getElementById("bDocumento").style.display="none";
         document.getElementById("bRUT").style.display="block";
          document.getElementById("bRazon").style.display="none";
          document.getElementById("cantidadCheques").style.display="block";
      }else if(busqueda=="4"){
        this.Cheques=[];
        document.getElementById('pdf').src="";
        document.getElementById("bVendedor").style.display="none";
        document.getElementById("bDocumento").style.display="none";
        document.getElementById("bRUT").style.display="none";
        document.getElementById("bRazon").style.display="block";
        document.getElementById("cantidadCheques").style.display="none";
      }

    },
    buscarDocumento(){
        
        var documento= document.getElementById("numero").value;
         db.collection('cheques').where("documento", "==", documento).onSnapshot((snapshotChange) => {
                this.Cheques = [];
                if(snapshotChange.empty){
                   Swal.fire({
                      title: "Error",
                      text: "No se encontraron cheques",
                      icon: "error",
                    });
                }else{
                    snapshotChange.forEach((doc) => {
                    this.Cheques.push({
                       key: doc.id,
                        documento: doc.data().documento,
                        rut: doc.data().rut,
                        nombreTitular: doc.data().nombreTitular,
                        rutFacturacion: doc.data().rutFacturacion,
                        razonSocial: doc.data().razonSocial,
                        observacion: doc.data().observacion, 
                        monto: doc.data().monto,
                        imagen: doc.data().imagen,
                        fecha: doc.data().fecha+" "+doc.data().hora,
                    })
                });
                }
               
          })
    },
    buscarVendedor(){
       var vendedor= document.getElementById("vendedor").value;
       var fecha1= document.getElementById("fecha1v").value;
       var fecha2= document.getElementById("fecha2v").value;
       
               var fecha12=fecha1.split("-");
                var año=fecha12[0]
                var mes=fecha12[1]
                var dia=fecha12[2]
               //var fechaF1=dia+"-"+mes+"-"+año;
                var fechaFF1=año+mes+dia
                
                var fecha22=fecha2.split("-");
                var año2=fecha22[0]
                var mes2=fecha22[1]
                var dia2=fecha22[2]
                //var fechaF2=dia2+"-"+mes2+"-"+año2;
                 var fechaFF2=año2+mes2+dia2
         //db.collection('cheques').where("usuario", "==", vendedor).where("fecha", ">=", fechaF1).where("fecha", "<=", fechaF2).orderBy('fecha', 'desc').orderBy('hora', 'desc').onSnapshot((snapshotChange) => {
db.collection('cheques').where("usuario", "==", vendedor).where("fr", ">=", fechaFF1).where("fr", "<=", fechaFF2).orderBy('fr', 'desc').orderBy('hora', 'desc').onSnapshot((snapshotChange) => {
          
                this.Cheques = [];
                if(snapshotChange.empty){
                  Swal.fire({
                      title: "Error",
                      text: "No se encontraron cheques",
                      icon: "error",
                    });
                }else{
                    this.largo=(snapshotChange.docs.length)
                    snapshotChange.forEach((doc) => {
                      
                    this.Cheques.push({
                       key: doc.id,
                        documento: doc.data().documento,
                        rut: doc.data().rut,
                        nombreTitular: doc.data().nombreTitular,
                        rutFacturacion: doc.data().rutFacturacion,
                        razonSocial: doc.data().razonSocial,
                        observacion: doc.data().observacion, 
                        monto: doc.data().monto,
                        imagen: doc.data().imagen,
                        fecha: doc.data().fecha+" "+doc.data().hora,
                    })
                });
                }
               
          })
    },
    buscarRut(){
       var rut= document.getElementById("rut").value;
       var fecha1= document.getElementById("fecha1RUT").value;
       var fecha2= document.getElementById("fecha2RUT").value;
       
                var fecha12=fecha1.split("-");
                var año=fecha12[0]
                var mes=fecha12[1]
                var dia=fecha12[2]
               //var fechaF1=dia+"-"+mes+"-"+año;
                var fechaFF1=año+mes+dia
                
                var fecha22=fecha2.split("-");
                var año2=fecha22[0]
                var mes2=fecha22[1]
                var dia2=fecha22[2]
                //var fechaF2=dia2+"-"+mes2+"-"+año2;
                 var fechaFF2=año2+mes2+dia2
         db.collection('cheques').where("rutFacturacion", "==", rut).where("fr", ">=", fechaFF1).where("fr", "<=", fechaFF2).orderBy('fr', 'desc').orderBy('hora', 'desc').onSnapshot((snapshotChange) => {
                this.Cheques = [];
                if(snapshotChange.empty){
                  Swal.fire({
                      title: "Error",
                      text: "No se encontraron cheques",
                      icon: "error",
                    });
                }else{
                  this.largo=(snapshotChange.docs.length)
                    snapshotChange.forEach((doc) => {
                    this.Cheques.push({
                       key: doc.id,
                        documento: doc.data().documento,
                        rut: doc.data().rut,
                        nombreTitular: doc.data().nombreTitular,
                        rutFacturacion: doc.data().rutFacturacion,
                        razonSocial: doc.data().razonSocial,
                        observacion: doc.data().observacion, 
                        monto: doc.data().monto,
                        imagen: doc.data().imagen,
                        fecha: doc.data().fecha+" "+doc.data().hora,
                    })
                });
                }
               
          })
    },
    buscarRazon(){
       var razon= document.getElementById("razon").value;
       var fecha1= document.getElementById("fecha1Razon").value;
       var fecha2= document.getElementById("fecha2Razon").value;
       
                 var fecha12=fecha1.split("-");
                var año=fecha12[0]
                var mes=fecha12[1]
                var dia=fecha12[2]
               //var fechaF1=dia+"-"+mes+"-"+año;
                var fechaFF1=año+mes+dia
                
                var fecha22=fecha2.split("-");
                var año2=fecha22[0]
                var mes2=fecha22[1]
                var dia2=fecha22[2]
                //var fechaF2=dia2+"-"+mes2+"-"+año2;
                 var fechaFF2=año2+mes2+dia2
         db.collection('cheques').where("razonSocial", "==", razon).where("fr", ">=", fechaFF1).where("fr", "<=", fechaFF2).orderBy('fr', 'desc').orderBy('hora', 'desc').onSnapshot((snapshotChange) => {
                this.Cheques = [];
                if(snapshotChange.empty){
                   Swal.fire({
                      title: "Error",
                      text: "No se encontraron cheques",
                      icon: "error",
                    });
                }else{
                    snapshotChange.forEach((doc) => {
                    this.Cheques.push({
                       key: doc.id,
                        documento: doc.data().documento,
                        rut: doc.data().rut,
                        nombreTitular: doc.data().nombreTitular,
                        rutFacturacion: doc.data().rutFacturacion,
                        razonSocial: doc.data().razonSocial,
                        observacion: doc.data().observacion, 
                        monto: doc.data().monto,
                        imagen: doc.data().imagen,
                        fecha: doc.data().fecha+" "+doc.data().hora,
                    })
                });
                }
               
          })
    },
    cargarDatos(key){
         var chequeEditado = new Object();
								chequeEditado.key=key;
                                chequeEditado.imagen="";
                                chequeEditado.estado="pendiente";
								this.chequeEditado.push(chequeEditado)
                this.editar2();
    },
    
    editar2(){
        if (window.confirm("Realmente deseas eliminar la relación del archivo?")) {
       var data=this.chequeEditado;
                data.forEach((doc) => {
                    db.collection('cheques').doc(doc.key)
                    .update(doc).then(() => {
                        console.log("Cheque actualizado");
                        Swal.fire({
                        title: "Listo",
                        text: "Cheques editado",
                        icon: "success",
                        })
                        this.chequeEditado=[];
                        this.$bvModal.hide("modal-1")
                        document.getElementById('pdf').src="";
                        //this.Cheques=[];
                        //document.getElementById("archivo").value="";
                        //this.imagen=null;

                    }).catch((error) => {
                        console.log(error);
                    });
                });
        }       
    },
     validarUsuario(){
             //document.getElementById("monto").display = "none";   
            if(this.usuario==undefined || this.usuario=="X"){
                this.$router.push('/')
            }
        },
      leer(){
                var rut = document.getElementById("rut").value;
				var rutx=rut.replace("-","");
				var largo=rutx.length
				//console.log(largo,largo-1)
				var rut2=rutx.slice(0,largo-1)
				var rut3=rutx.slice(largo-1)
                //console.log(rut2+"-"+rut3)
				document.getElementById("rut").value=(rut2+"-"+rut3)
				
      }
  
    
  },
};
</script>

<style>
.btn-primary {
  margin-right: 12px;
}
</style>